<template>
  <v-item-group class="pb-10" id="emission">
    <v-row class="pb-4">
      <v-col cols="12">
        <p class="quotation-title gray--text font-weight-bold">
          TIPO DE EMISSÃO
        </p>
      </v-col>
      <v-col
        v-for="(item, key) of items"
        :key="key"
        cols="12"
        sm="5"
        md="3"
        class="pr-5 pb-5 pb-md-0 d-flex justify-center justify-sm-start"
      >
        <QuotationCard
          @click="selectedItem(item)"
          :name="item.nome"
          :text="item.subtitulo"
          :class="{ 'base-card-active': item === model }"
          :name-icon="list[key].image"
          :icon-default="false"
        />
      </v-col>
    </v-row>
  </v-item-group>
</template>
<script>
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";
const emissionType = [
  {
    title: "Novo",
    text: "Judicial Depósito Recursal",
    id: "novo",
    image: require("@/assets/novo.png")
  },
  {
    title: "Substituição",
    text: "Judicial Depósito Recursal",
    id: "substituicao",
    image: require("@/assets/substituicao1.png")
  }
];
export default {
  data: () => ({
    list: emissionType
  }),
  components: {
    QuotationCard: CardDescriptionButton
  },
  mounted() {
    document.getElementById("emission").scrollIntoView();
  },
  methods: {
    selectedItem(item) {
      this.$emit("emission", item);
    }
  },
  props: {
    model: {
      type: Object
    },
    items: {
      type: Array
    }
  }
};
</script>
<style lang="sass" scoped></style>
